import Axios, { AxiosRequestConfig } from "axios";
import { Auth } from "aws-amplify";
import { environment } from "./Environment";

const endpoint: string = environment.outputs.ApiUrl;

const axios = Axios.create({
  baseURL: endpoint,
});

type Options = {
  path: string;
};

type OptionsWithPayload<D = any> = Options & {
  data?: D;
};

const authorizationHeader = async () => {
  return (await Auth.currentSession()).getIdToken().getJwtToken();
};

export const post = async <R = any, D = any>(
  { path, data }: OptionsWithPayload<D>,
  config?: AxiosRequestConfig
) => {
  return axios.post<R>(path, data, {
    ...config,
    headers: {
      ...config?.headers,
      Authorization: await authorizationHeader(),
    },
  });
};

export const patch = async <R = any, D = any>(
  { path, data }: OptionsWithPayload<D>,
  config?: AxiosRequestConfig
) => {
  return axios.patch<R>(path, data, {
    ...config,
    headers: {
      ...config?.headers,
      Authorization: await authorizationHeader(),
    },
  });
};

export const del = async <R = any>(
  { path }: Options,
  config?: AxiosRequestConfig
) => {
  return axios.delete<R>(path, {
    ...config,
    headers: {
      ...config?.headers,
      Authorization: await authorizationHeader(),
    },
  });
};

export const get = async <R = any>(
  { path }: Options,
  config?: AxiosRequestConfig
) => {
  return axios.get<R>(path, {
    ...config,
    headers: {
      ...config?.headers,
      Authorization: await authorizationHeader(),
    },
  });
};
